// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchResultEmpty__wrapper","container":"SearchResultEmpty__container","picture":"SearchResultEmpty__picture","icon":"SearchResultEmpty__icon"};